export interface InfoStepsItem {
  title: string;
  content: React.ReactElement | string;
}
export interface InfoStepsProps {
  items: InfoStepsItem[];
}

function InfoSteps(props: InfoStepsProps) {
  if (!props.items) return (null);

  return (
    <div className="ct_infoSteps">
      {props.items.map((item, index) => (
        <div key={index} className="ct_infoSteps-item">
          <div className="ct_infoSteps-title">{item.title}</div>
          <div className="ct_infoSteps-content">
            {item.content}
          </div>
        </div>
      ))}
    </div>
  );
}

export default InfoSteps;
